<template>
  <section class="band" id="operators">
    <div class="wrap">
      <div class="head c">
        <h2 class="h2">How it works</h2>
      </div>
      <div class="steps mt">
        <div class="card step">
          <div class="ico" style="background:var(--p-blue)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8"/><path d="M10 19v-3.96 3.15"/><path d="M7 19h5"/><rect width="6" height="10" x="16" y="12" rx="2"/></svg></div>
          <span class="n">Step 1</span>
          <h3>Connect your screens</h3>
          <p>Pair any LED or LCD screen with an Adverpost player or Android device.</p>
        </div>
        <div class="card step">
          <div class="ico" style="background:var(--p-amber)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h5"/><path d="M17.5 17.5 16 16.3V14"/><circle cx="16" cy="16" r="6"/></svg></div>
          <span class="n">Step 2</span>
          <h3>Schedule your content</h3>
          <p>Set it once, or let e2v run it from your own data.</p>
        </div>
        <div class="card step">
          <div class="ico" style="background:var(--p-teal)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 18V6"/></svg></div>
          <span class="n">Step 3</span>
          <h3>Start earning</h3>
          <p>Show your own ads, or list your screens to take bookings.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- PLATFORM -->
</template>

<script>
// Extracted verbatim from public/landing/index.html; in-page anchors emit
// instead of navigating, because the app uses a hash router.
export default { name: "HowItWorks" };
</script>
